import { useState } from "react";
import Config from "../../../Config";
import MediaBrowser from "../../../helpers/MediaBrowser";


function Eat(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);



    const getData = () => {


        props.mainView.setProgress(-2);

        var req = {

        };


        fetch( Config.url + '/rest_v1_parents,eat', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                                                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
               



    }


    if(tab == null)
        {
            setTab([]);
            getData();      
            return (
                <div></div>
            );        
        }


    
    if(refreshView != props.userData.refreshView)
    {         
          setRefreshView( props.userData.refreshView);
    }    
    
    

    return (
        <div>
            <ul className="parents_eat">

           
               {
                tab.map( (item, inx) => {

                    return <li key={inx}>

                                 <div className="calColor" >Jadłospis na {item.dzien_od}</div>

                                  {
                                    item.txt.length == 0 &&  item.file.length == 0 &&
                                    <div>
                                        <br/>Nie podano.
                                    </div>
                                  }  
                                

                                {
                                    item.txt.length > 0 &&
                                    <ul>
                                            {
                                                item.txt.map( (txt, txtInx) => {
                                                        return <li>
                                                            {txt.godzina}, {txt.tresc}
                                                        </li>
                                                } )
                                            }
                                    </ul>
                                }  


                                {
                                    item.file.length > 0 &&
                                    <ul>
                                            {
                                                item.file.map( (ff, txtInx) => {
                                                        return <li>
                                                              <MediaBrowser userData={props.userData} mainView={props.mainView}  className="ico_directory" review={ff.b64} typ={"none"} typId={-1}  crypt={ff.crypt}  />
                                                        </li>
                                                } )
                                            }
                                    </ul>
                                } 



                    </li>

                } )
               }

            </ul>
        </div>
    )
}


export default Eat;